// GoatCounter.jsx
import { useEffect } from 'react';

const SCRIPT_ID = 'goatcounter-script';

const GoatCounter = ({ siteCode, allowLocal = true }) => {
  useEffect(() => {
    // Check if script is already loaded
    if (document.getElementById(SCRIPT_ID)) {
      return;
    }

    // Optional: Allow counting on localhost for development
    if (allowLocal) {
      window.goatcounter = { allow_local: false };
    }

    // Load GoatCounter script
    const script = document.createElement('script');
    script.id = SCRIPT_ID;
    script.async = true;
    script.setAttribute('data-goatcounter', `https://${siteCode}.goatcounter.com/count`);
    script.src = '//gc.zgo.at/count.js';
    
    // Single page count function
    const countPage = () => {
      if (window.goatcounter) {
        window.goatcounter.count({
          path: window.location.pathname + window.location.search + window.location.hash,
          title: document.title,
          event: false,
        });
      }
    };

    // Only set up listeners once script is loaded
    script.onload = () => {
      countPage(); // Initial count
    };

    document.head.appendChild(script);
    
    // Cleanup
    return () => {
      const scriptElement = document.getElementById(SCRIPT_ID);
      if (scriptElement && scriptElement.parentNode) {
        scriptElement.parentNode.removeChild(scriptElement);
      }
    };
  }, [siteCode, allowLocal]); // Dependencies remain the same

  return null;
};

export default GoatCounter;